// Figma "Brand SaaS DS" primitives. Keyed like the variables:
// color/salem/700 -> colorPalette.salem[700]. Add shades here as components need them.
export const colorPalette = Object.freeze({
  mercury: Object.freeze({
    100: "#FAFAFA",
    300: "#E5E5E5",
    950: "#1A1A1A",
  }),
  mercuryAlpha: Object.freeze({
    5: "rgba(26, 26, 26, 0.05)",
    8: "rgba(26, 26, 26, 0.08)",
    10: "rgba(26, 26, 26, 0.1)",
    12: "rgba(26, 26, 26, 0.12)",
    18: "rgba(26, 26, 26, 0.18)",
    28: "rgba(26, 26, 26, 0.28)",
    45: "rgba(26, 26, 26, 0.45)",
    55: "rgba(26, 26, 26, 0.55)",
    65: "rgba(26, 26, 26, 0.65)",
  }),
  cerulean: Object.freeze({
    100: "#ECF7FF",
    300: "#B2DDFF",
    700: "#006EFF",
    1000: "#0A2861",
  }),
  salem: Object.freeze({
    100: "#EBFEF4",
    300: "#A4F6CB",
    700: "#009B60",
    1000: "#012D20",
  }),
  yellow: Object.freeze({
    100: "#FFFDEA",
    300: "#FFE546",
    700: "#E28E00",
    1000: "#482000",
  }),
  red: Object.freeze({
    100: "#FEF3F2",
    300: "#FED0CA",
    600: "#EE4D37",
    700: "#DC3C26",
    800: "#B92F1C",
    1000: "#45110A",
  }),
  brand: Object.freeze({
    50: "#FFF4EC", // selected table row (hex from Figma, variable name unknown)
    100: "#FFF8EC",
    200: "#FFEFD3",
    300: "#FFDAA5",
    700: "#FF6600",
    800: "#CC4802",
    900: "#A1390B",
  }),
  purple: Object.freeze({
    100: "#FAF6FE",
    300: "#E9D8FC",
    700: "#9241DC",
    1000: "#3A0E5D",
  }),
  accentPurple: Object.freeze({
    bg: "#FAF6FE",
    solid: "#9241DC",
    content: "#6A2C9D",
  }),
});

export default colorPalette;
